export enum MailersLogStatus {
  SUCESSO = 'sucesso',
  ERROR = 'error',
  PENDENTE = 'pendente',
}

export function normalizeMailerLogStatus(raw: unknown): MailersLogStatus {
  if (raw === true || raw === 1) return MailersLogStatus.SUCESSO;
  if (raw === false || raw === 0) return MailersLogStatus.ERROR;
  const s = String(raw ?? '')
    .toLowerCase()
    .trim();
  if (s === '1' || s === 'true') return MailersLogStatus.SUCESSO;
  if (s === '0' || s === 'false') return MailersLogStatus.ERROR;
  if (s === MailersLogStatus.SUCESSO) return MailersLogStatus.SUCESSO;
  if (s === MailersLogStatus.ERROR) return MailersLogStatus.ERROR;
  if (s === MailersLogStatus.PENDENTE) return MailersLogStatus.PENDENTE;
  return MailersLogStatus.ERROR;
}

export function mailerLogStatusPillClass(
  status: unknown
): 'ok' | 'err' | 'pendente' {
  const s = normalizeMailerLogStatus(status);
  if (s === MailersLogStatus.SUCESSO) return 'ok';
  if (s === MailersLogStatus.PENDENTE) return 'pendente';
  return 'err';
}

export function mailerLogStatusTooltipType(
  status: unknown
): 'success' | 'error' | 'warning' {
  const s = normalizeMailerLogStatus(status);
  if (s === MailersLogStatus.SUCESSO) return 'success';
  if (s === MailersLogStatus.PENDENTE) return 'warning';
  return 'error';
}
